export const ANALYTICS_EVENTS = {
  // Auth
  AUTH_SIGNUP: 'auth.signup',
  AUTH_LOGIN: 'auth.login',
  AUTH_LOGOUT: 'auth.logout',
  AUTH_ACCOUNT_DELETED: 'auth.account.deleted',

  // Diagnostic
  DIAGNOSTIC_STARTED: 'diagnostic.started',
  DIAGNOSTIC_QUESTION_ANSWERED: 'diagnostic.question.answered',
  DIAGNOSTIC_ABANDONED: 'diagnostic.abandoned',
  DIAGNOSTIC_COMPLETED: 'diagnostic.completed',
  DIAGNOSTIC_PROFILE_INVALID: 'diagnostic.profile.invalid',
  DIAGNOSTIC_UPGRADE_PROMPT_SHOWN: 'diagnostic.upgrade.prompt.shown',
  DIAGNOSTIC_UPGRADE_PROMPT_ACCEPTED: 'diagnostic.upgrade.prompt.accepted',
  DIAGNOSTIC_UPGRADE_PROMPT_DISMISSED: 'diagnostic.upgrade.prompt.dismissed',

  // Profile
  PROFILE_VIEWED: 'profile.viewed',
  PROFILE_SHARED: 'profile.shared',
  PROFILE_RETAKE_STARTED: 'profile.retake.started',

  // Content
  CONTENT_UPLOAD_STARTED: 'content.upload.started',
  CONTENT_UPLOAD_COMPLETED: 'content.upload.completed',
  CONTENT_UPLOAD_FAILED: 'content.upload.failed',
  CONTENT_PRIOR_KNOWLEDGE_COMPLETED: 'content.prior.knowledge.completed',
  CONTENT_KNOWLEDGE_GRAPH_VIEWED: 'content.knowledge.graph.viewed',
  CONTENT_DELETED: 'content.deleted',

  // Learning Session
  LEARNING_SESSION_STARTED: 'learning.session.started',
  LEARNING_SECTION_VIEWED: 'learning.section.viewed',
  LEARNING_SECTION_COMPLETED: 'learning.section.completed',
  LEARNING_SECTION_SKIPPED: 'learning.section.skipped',
  LEARNING_SECTION_REVISITED: 'learning.section.revisited',
  LEARNING_VIDEO_PLAYED: 'learning.video.played',
  LEARNING_VIDEO_COMPLETED: 'learning.video.completed',
  LEARNING_VIDEO_SKIPPED: 'learning.video.skipped',
  LEARNING_DEEPER_TOGGLED: 'learning.deeper.toggled',
  LEARNING_SESSION_ENDED: 'learning.session.ended',
  LEARNING_SESSION_ABANDONED: 'learning.session.abandoned',

  // Checkpoint
  CHECKPOINT_PRESENTED: 'checkpoint.presented',
  CHECKPOINT_COMPLETED: 'checkpoint.completed',
  CHECKPOINT_SKIPPED: 'checkpoint.skipped',
  CHECKPOINT_HUMOR_REACTED: 'checkpoint.humor.reacted',

  // Tutor
  TUTOR_PANEL_OPENED: 'tutor.panel.opened',
  TUTOR_PANEL_CLOSED: 'tutor.panel.closed',
  TUTOR_QUERY_SENT: 'tutor.query.sent',
  TUTOR_RESPONSE_RECEIVED: 'tutor.response.received',
  TUTOR_FEEDBACK_GIVEN: 'tutor.feedback.given',
  TUTOR_QUERY_LIMIT_REACHED: 'tutor.query.limit.reached',
  TUTOR_HIGHLIGHT_CONTEXT: 'tutor.highlight.context',

  // Adaptive
  ADAPTIVE_PROFILE_RECALIBRATED: 'adaptive.profile.recalibrated',
  ADAPTIVE_PATH_ADJUSTED: 'adaptive.path.adjusted',

  // Feedback
  FEEDBACK_SUBMITTED: 'feedback.submitted',

  // Adaptation History
  ADAPTATION_HISTORY_VIEWED: 'adaptation.history.viewed',
  ADAPTATION_RESPONSE_SUBMITTED: 'adaptation.response.submitted',
  ADAPTATION_REVERSAL_APPLIED: 'adaptation.reversal.applied',
  ADAPTATION_USER_ADJUSTMENT_APPLIED: 'adaptation.user.adjustment.applied',

  // Tutor Adaptation Mode
  TUTOR_ADAPTATION_STARTED: 'tutor.adaptation.started',
  TUTOR_ADAPTATION_PROPOSAL_SHOWN: 'tutor.adaptation.proposal.shown',
  TUTOR_ADAPTATION_PROPOSAL_ACCEPTED: 'tutor.adaptation.proposal.accepted',
  TUTOR_ADAPTATION_PROPOSAL_REJECTED: 'tutor.adaptation.proposal.rejected',

  // Subscription
  SUBSCRIPTION_PAYWALL_SHOWN: 'subscription.paywall.shown',
  SUBSCRIPTION_UPGRADE_STARTED: 'subscription.upgrade.started',
  SUBSCRIPTION_UPGRADE_COMPLETED: 'subscription.upgrade.completed',
  SUBSCRIPTION_UPLOAD_PURCHASED: 'subscription.upload.purchased',
  SUBSCRIPTION_UPLOAD_COUNTER_VIEWED: 'subscription.upload.counter.viewed',
  SUBSCRIPTION_CANCELLED: 'subscription.cancelled',
  SUBSCRIPTION_REACTIVATED: 'subscription.reactivated',
  SUBSCRIPTION_PAYMENT_SUCCEEDED: 'subscription.payment.succeeded',
  SUBSCRIPTION_PAYMENT_FAILED: 'subscription.payment.failed',

  // Recalibration (v2)
  RECAL_SCHEDULE_CREATED: 'recal.schedule.created',
  RECAL_COUNTDOWN_VIEWED: 'recal.countdown.viewed',
  RECAL_PREVIEW_STARTED: 'recal.preview.started',
  RECAL_PREVIEW_COMPLETED: 'recal.preview.completed',
  RECAL_PREVIEW_HEADLINE_SHOWN: 'recal.preview.headline.shown',
  RECAL_OFFER_CARD_VIEWED: 'recal.offer.card.viewed',
  RECAL_OFFER_EMAIL_SENT: 'recal.offer.email.sent',
  RECAL_OFFER_CLICKED: 'recal.offer.clicked',
  RECAL_OFFER_REDEEMED: 'recal.offer.redeemed',
  RECAL_OFFER_EXPIRED: 'recal.offer.expired',
  RECAL_CHECK_STARTED: 'recal.check.started',
  RECAL_CHECK_COMPLETED: 'recal.check.completed',
  RECAL_FULL_STARTED: 'recal.full.started',
  RECAL_FULL_COMPLETED: 'recal.full.completed',
  RECAL_SOFT_RESET_PROMPTED: 'recal.softReset.prompted',
  RECAL_SOFT_RESET_ACCEPTED: 'recal.softReset.accepted',
  RECAL_SUGGESTION_CLASSIFIED: 'recal.suggestion.classified',
  RECAL_MONTHLY_REPORT_GENERATED: 'recal.monthlyReport.generated',
  RECAL_MONTHLY_REPORT_OPENED: 'recal.monthlyReport.opened',
  RECAL_AUTO_PILOT_SUGGESTION_SHOWN: 'recal.autoPilot.suggestion.shown',
  RECAL_AUTO_PILOT_ACCEPTED: 'recal.autoPilot.accepted',

  // App
  APP_PAGE_VIEWED: 'app.page.viewed',
  APP_FEATURE_DISCOVERED: 'app.feature.discovered',
  APP_ERROR_ENCOUNTERED: 'app.error.encountered',
  APP_EXPORT_INITIATED: 'app.export.initiated',
  APP_THEME_TOGGLED: 'app.theme.toggled',
} as const;

export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS];
